import { CookieKey, getCookie, setCookie, getServerUrl } from 'mt-shared';
import { SUPPORT_USER, SUPPORT_SESSION, inSupportMode, DEMO_SESSION, DEMO_USER, inDemoMode } from '@app/lib/remote-login';

const SERVER_URL: string = getServerUrl();
const AUTH_TOKEN: string = getCookie(CookieKey.AUTH_TOKEN);

let basicHeaders;
let supportModeHeaders = {};
let demoModeHeaders = {};

if (inDemoMode() || inSupportMode()) {
  basicHeaders = {
    'X-Web-User-Auth': getCookie(CookieKey.REMOTE_LOGIN_TOKEN),
  };
} else if (AUTH_TOKEN) {
  basicHeaders = {
    'X-Web-User-Auth': AUTH_TOKEN,
  };
}

if (inSupportMode()) {
  supportModeHeaders = {
    'X-Skip-User-Stats': 'true',
    'X-Hijacker': SUPPORT_USER,
    'X-Hijacker-Session': SUPPORT_SESSION,
  };
} else if (inDemoMode()) {
  demoModeHeaders = {
    'X-Skip-User-Stats': 'true',
    'X-Demo-User': DEMO_USER,
    'X-Demo-Session': DEMO_SESSION,
  };
}

export const defaultHeaders = Object.assign({}, basicHeaders, supportModeHeaders, demoModeHeaders);

export function overrideGeoTabAuthToken(authToken) {
  const domain: string = new URL(SERVER_URL)?.hostname;

  setCookie(CookieKey.AUTH_TOKEN, authToken, { path: '/', domain: `.${domain}`, sameSite: 'none', secure: true });
  defaultHeaders['X-Web-User-Auth'] = authToken;
}

export function overrideAuthToken(authToken) {
  setCookie(CookieKey.AUTH_TOKEN, authToken);
  defaultHeaders['X-Web-User-Auth'] = authToken;
}
